import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["frame", "placeholder"];
  static values = { src: String };

  connect() {
    if ("IntersectionObserver" in window) {
      this.observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            this.load();
            this.observer.disconnect();
          }
        });
      }, { rootMargin: "200px" });
      this.observer.observe(this.element);
    } else {
      this.load();
    }
  }

  disconnect() {
    this.observer?.disconnect();
  }

  srcValueChanged() {
    if (this.hasFrameTarget && this.frameTarget.src && !this.frameTarget.src.endsWith("about:blank")) {
      this.load(true);
    }
  }

  load(force = false) {
    if (!this.hasFrameTarget || !this.srcValue) return;
    if (!force && this.frameTarget.src && !this.frameTarget.src.endsWith("about:blank")) return;

    this.placeholderTarget?.classList.remove("hidden");
    this.frameTarget.addEventListener("load", () => this.hidePlaceholder(), { once: true });
    this.frameTarget.addEventListener("error", () => this.hidePlaceholder(), { once: true });
    // Don't leave "loading" forever if Maps is blocked/slow
    window.clearTimeout(this._fallbackTimer);
    this._fallbackTimer = window.setTimeout(() => this.hidePlaceholder(), 4000);
    this.frameTarget.src = this.srcValue;
  }

  hidePlaceholder() {
    window.clearTimeout(this._fallbackTimer);
    this.placeholderTarget?.classList.add("hidden");
  }
}
